module.exports = __webpack_public_path__ + "img/第3章_3-2_孔廟謎題圖_疊圖2.jpg";